/**
 * base module
 * @type {string}
 */
export const SET_USER_INFO = 'SET_USER_INFO'

export const SET_TOKEN = 'SET_TOKEN'

export const SET_ROUTES = 'SET_ROUTES'

export const SET_ROLE = 'SET_ROLE'


/**
 * setting module
 * @type {string}
 */
export const SET_IS_MOBILE = 'SET_IS_MOBILE'

export const SET_THEME = 'SET_THEME'

export const SET_LAYOUT = 'SET_LAYOUT'

export const SET_MULTIPAGE = 'SET_MULTIPAGE'

export const SET_FIXED_HEADER = 'SET_FIXED_HEADER'

export const SET_FIXED_SIDEBAR = 'SET_FIXED_SIDEBAR'

export const SET_REVIEW_OPERATION = 'SET_REVIEW_OPERATION'



export const SET_COPYRIGHT = 'SET_COPYRIGHT'

export const SET_LICENSE_NUMBER = 'SET_LICENSE_NUMBER'

export const SET_SYSTEM_NAME = 'SET_SYSTEM_NAME'

export const SET_PAYMENT_EARNEST_MONEY_MANAGEMENT_TYPE = 'SET_PAYMENT_EARNEST_MONEY_MANAGEMENT_TYPE'

export const SET_IS_INIT = 'SET_IS_INIT'

export const SET_LOGIN_URL = 'SET_LOGIN_URL'
export const SET_REGISTER_URL = 'SET_REGISTER_URL'
export const SET_SUPERVISION_URL = 'SET_SUPERVISION_URL'

export const SET_MARGIN_AMOUNT_STATISTICS = 'SET_MARGIN_AMOUNT_STATISTICS'
export const SET_TECHNICAL_SUPPORT = 'SET_TECHNICAL_SUPPORT'
export const SHOW_COMPLAINTS = 'SHOW_COMPLAINTS'
export const SHOW_CREDIT_PUBLICITY = 'SHOW_CREDIT_PUBLICITY'
export const SHOW_ENTERPRISE_CENTER = 'SHOW_ENTERPRISE_CENTER'
export const SHOW_HANDLING_GUIDE = 'SHOW_HANDLING_GUIDE'
export const SHOW_INDEX = 'SHOW_INDEX'
export const SHOW_ORG_PUBLICITY = 'SHOW_ORG_PUBLICITY'
export const SHOW_POLICIES_REGULATIONS = 'SHOW_POLICIES_REGULATIONS'
export const SHOW_SUPERVISION_CENTER = 'SHOW_SUPERVISION_CENTER'
export const SHOW_POLICY_VERIFICATION = 'SHOW_POLICY_VERIFICATION'

export const SET_DOMAIN_NAME_TITLE = 'SET_DOMAIN_NAME_TITLE'

export const SET_VERSION = 'SET_VERSION'